import { useState, useContext, useEffect } from 'react';
import classes from './ProfileSection.module.scss';
import i18n from '../../../../utils/i18n';
import { Button, Divider, Menu, MenuItem } from '@mui/material';
import ProfileSettingsTab from './ProfileSectionTabs/ProfileSettingsTab';
import CompanyInfoTab from './ProfileSectionTabs/CompanyInfoTab';
import ClientFiltersTab from './ProfileSectionTabs/ClientFiltersTab';
import ServicesTab from './ProfileSectionTabs/ServicesTab';
import PricingTab from './ProfileSectionTabs/PricingTab';
import ReviewsTab from './ProfileSectionTabs/ReviewsTab';
import FooterSave from '../../../components/FooterSave';
import SelectorArrowDown from '../../../../images/selector-arrow-down.svg';
import { Alert } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import { useDispatch } from 'react-redux';
import ACTIONS from '../../../../redux/action';
import ProfileTabContext from '../../context/ProfileTabContext';

// import { ProviderProps } from '../../ProviderDashboard';

const ProfileSection = ({
	providerData,
	fetchProviderData,
	addProviderInfo,
	submitToDB,
	allCompleted,
}) => {
	const { activeProfileTab, setActiveProfileTab } =
		useContext(ProfileTabContext);
	const [openSnack, setOpenSnack] = useState(false);
	const [saveMessage, setSaveMessage] = useState(i18n.t('general.savesuccess'));
	const [severity, setSeverity] = useState('success');
	const [screenWidth, setScreenWidth] = useState(window.innerWidth);
	const [menuAnchor, setMenuAnchor] = useState(null);
	const dispatch = useDispatch();
	useEffect(() => {
		const handleResize = () => setScreenWidth(window.innerWidth);
		window.addEventListener('resize', handleResize);

		return () => window.removeEventListener('resize', handleResize);
	}, []);

	const handleClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}

		setOpenSnack(false);
	};
	// console.log(providerData, 'providerData');

	// const tabs: string[] = [
	const tabs = [
		{ label: i18n.t('provider.profilesettings'), id: 'profilesettings' },
		{ label: i18n.t('provider.companyinfo'), id: 'companyinfo' },
		{ label: i18n.t('provider.services'), id: 'services' },
		{ label: i18n.t('provider.clientfilters'), id: 'clientfilters' },
		{ label: i18n.t('provider.pricing'), id: 'pricing' },
		{ label: i18n.t('general.reviews'), id: 'reviews' },
	];

	const renderTabContent = () => {
		switch (activeProfileTab) {
			case 'profilesettings':
				return (
					<ProfileSettingsTab
						providerData={providerData}
						fetchProviderData={fetchProviderData}
						addProviderInfo={addProviderInfo}
						submitToDB={submitToDB}
						allCompleted={allCompleted}
					/>
				);
			case 'companyinfo':
				return (
					<CompanyInfoTab
						providerData={providerData}
						fetchProviderData={fetchProviderData}
						addProviderInfo={addProviderInfo}
						submitToDB={submitToDB}
					/>
				);
			case 'clientfilters':
				return (
					<ClientFiltersTab
						providerData={providerData}
						fetchProviderData={fetchProviderData}
						addProviderInfo={addProviderInfo}
						submitToDB={submitToDB}
					/>
				);
			case 'services':
				return (
					<ServicesTab
						providerData={providerData}
						fetchProviderData={fetchProviderData}
						addProviderInfo={addProviderInfo}
						submitToDB={submitToDB}
					/>
				);
			case 'pricing':
				return (
					<PricingTab
						providerData={providerData}
						fetchProviderData={fetchProviderData}
						addProviderInfo={addProviderInfo}
						submitToDB={submitToDB}
						setSaveMessage={setSaveMessage}
						setSeverity={setSeverity}
					/>
				);
			case 'reviews':
				return (
					<ReviewsTab
						providerData={providerData}
						fetchProviderData={fetchProviderData}
						addProviderInfo={addProviderInfo}
						submitToDB={submitToDB}
						setSaveMessage={setSaveMessage}
						setSeverity={setSeverity}
					/>
				);
			default:
				return null;
		}
	};

	return (
		<div className={classes.dashboard}>
			<Snackbar
				open={openSnack}
				autoHideDuration={3000}
				onClose={(e) => handleClose(e)}>
				<Alert
					onClose={handleClose}
					severity={severity}
					variant='filled'
					sx={{ width: '100%' }}>
					{saveMessage}
				</Alert>
			</Snackbar>

			<Divider />

			<div className={classes.tabContainer}>
				<div className={classes.containerWrapper}>
					<Snackbar
						open={openSnack}
						autoHideDuration={3000}
						onClose={(e) => handleClose(e)}>
						<Alert
							onClose={handleClose}
							severity={severity}
							variant='filled'
							sx={{ width: '100%' }}>
							{saveMessage}
						</Alert>
					</Snackbar>

					<div className={classes.title}>{i18n.t('provider.profile')}</div>

					<Divider />

					<div className={classes.tabContainer}>
						<div className={classes.tabSubContainer}>
							{screenWidth < 480 ? (
								<>
									<Button
										onClick={(e) => setMenuAnchor(e.currentTarget)}
										variant='outlined'
										sx={{
											width: '100%',
											display: 'flex',
											justifyContent: 'space-between',
											textTransform: 'none',
											fontWeight: 500,
											fontSize: '14px',
											padding: '8px 18px',
											color: '#0B0F31',
											borderColor: '#E3E5E9',
											borderRadius: '8px',
											fontFamily: 'Satoshi, sans-serif',
											alignItems: 'center',
											gap: '8px',
										}}>
										{tabs.find((tab) => tab.id === activeProfileTab)?.label}
										<img
											src={SelectorArrowDown}
											alt={i18n.t('general.arrowDown')}
										/>
									</Button>
									<Menu
										anchorEl={menuAnchor}
										open={Boolean(menuAnchor)}
										onClose={() => setMenuAnchor(null)}
										slotProps={{
											paper: { sx: { borderRadius: '8px' } },
										}}>
										{tabs.map((tab) => (
											<MenuItem
												key={tab.id}
												onClick={() => {
													setActiveProfileTab(tab.id);
													setMenuAnchor(null);
												}}>
												{tab.label}
											</MenuItem>
										))}
									</Menu>
								</>
							) : (
								tabs.map((tab) => (
									<Button
										key={tab.id}
										onClick={() => setActiveProfileTab(tab.id)}
										variant='text'
										sx={{
											flex: 1,
											textAlign: 'center',
											textTransform: 'none',
											fontWeight: 700,
											fontSize: '12px',
											padding: '8px 18px',
											color:
												activeProfileTab === tab.id ? '#ffffff' : '#0b0f31',
											backgroundColor:
												activeProfileTab === tab.id ? '#1c32f3' : 'transparent',
											fontFamily: 'Satoshi, sans-serif',
											borderRadius: '8px',
											boxShadow:
												activeProfileTab === tab.id ? '#00000033' : 'none',
											transition: 'color 0.2s ease, background-color 0.2s ease',
											'&:hover': {
												color:
													activeProfileTab === tab.id ? '#ffffff' : '#1c32f3',
												backgroundColor:
													activeProfileTab === tab.id
														? '#1c32f3'
														: 'transparent',
											},
										}}>
										{tab.label}
									</Button>
								))
							)}
						</div>
					</div>
				</div>
			</div>

			<Divider />

			{renderTabContent()}

			<FooterSave
				addButtonActive={false}
				removeButtonActive={false}
				onSave={async () => {
					activeProfileTab === 'clientfilters' &&
						dispatch(
							ACTIONS.updateNestedObject({
								id: 'iscompleted',
								data: true,
								stateObject: 'provider_onboarding',
								stateObjectID: `clientfilters_flow`,
							})
						);
					activeProfileTab === 'services' &&
						dispatch(
							ACTIONS.updateNestedObject({
								id: 'iscompleted',
								data: true,
								stateObject: 'provider_onboarding',
								stateObjectID: `services_flow`,
							})
						);
					setTimeout(async () => {
						await submitToDB();
						setOpenSnack(true);
					}, 2000);
				}}
			/>
		</div>
	);
};

export default ProfileSection;
